export default {"src":"/_next/static/media/eyeIcon.9daf173b.svg","height":15,"width":22};